module.exports = __webpack_public_path__ + "img/bg_gallery.5df01d8f.jpg";